import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Sidebar, { MobileBottomNav } from "@/components/Sidebar";
import Dashboard from "@/pages/Dashboard";
import Movements from "@/pages/Movements";
import Stock from "@/pages/Stock";
import Orders from "@/pages/Orders";
import Suppliers from "@/pages/Suppliers";
import Inventory from "@/pages/Inventory";

function Shell({ children }) {
  return (
    <div className="min-h-screen bg-[color:var(--bg)]">
      <Sidebar />
      <MobileBottomNav />
      <main className="md:pl-[240px] pb-24 md:pb-0">
        <div className="max-w-[1400px] mx-auto p-5 md:p-8">
          {children}
        </div>
      </main>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Shell>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/mouvements" element={<Movements />} />
          <Route path="/stock" element={<Stock />} />
          <Route path="/commandes" element={<Orders />} />
          <Route path="/fournisseurs" element={<Suppliers />} />
          <Route path="/inventaire" element={<Inventory />} />
        </Routes>
      </Shell>
      <Toaster position="top-right" richColors closeButton />
    </BrowserRouter>
  );
}
